import React, { useState } from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import axiosInstance from '../../axiosConfig';

type Props = {
    id: number;
    clubNumberCountry: string;
};

const PdfLink: React.FC<Props> = ({ id, clubNumberCountry }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async () => {
        try {
            setIsLoading(true);
            const body = { id, club_number_country: clubNumberCountry } as const;
            const response = await axiosInstance.post('/association/invoice/file', body);
            const pdfUrl: unknown = (response as any)?.data?.pdf_url;
            console.log('invoice/file response:', response.data);
            if (typeof pdfUrl === 'string' && pdfUrl.length > 0) {
                window.open(pdfUrl, '_blank', 'noopener,noreferrer');
            } else {
                console.error('Invalid pdf_url in response:', response.data);
            }
        } catch (error) {
            console.error('invoice/file error:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const baseClasses = 'w-12 h-6 border rounded-sm transition-all duration-300 flex items-center justify-center font-bold text-sm';
    const enabledClasses = 'bg-gradient-to-r from-red-500/100 to-red-400 border-red-500/20 text-white shadow-md shadow-red-500/20 hover:brightness-110';
    const disabledClasses = 'bg-gray-200 border-gray-200 text-gray-400 cursor-not-allowed';

    return (
        <div className="flex items-center gap-2">
            {isLoading ? (
                <div className='w-12 h-6 flex items-center justify-center'><ArrowPathIcon className="w-5 h-5 animate-spin text-gray-500" /></div>
            ) : (<button
                type="button"
                onClick={handleClick}
                disabled={isLoading}
                className={`${baseClasses} ${isLoading ? disabledClasses : enabledClasses}`}
            >
                PDF
            </button>)}
        </div>
    );
};

export default PdfLink;



